// LogoutButton.js
import React from 'react';
import { signOut } from 'aws-amplify/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from "../../slices/authSlice";


import { Button } from '@mui/material';

export default function LogoutButton() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    dispatch(logout());
    navigate('/');
  };

  return (
        <Button 
            onClick={handleLogout}
            variant="contained"
            color="primary"
        >
            Logout
        </Button>
  );
}
